var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"small":"","color":_vm.color},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,slot){return {key:slot,fn:function(){return [_vm._t(slot)]},proxy:true}})],null,true)},'v-btn',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }